import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/www/pricing.bigam-dev.ru/data/www/client/layouts/default.vue").then(m => m.default || m)),
  fullpage: defineAsyncComponent(() => import("/var/www/pricing.bigam-dev.ru/data/www/client/layouts/fullpage.vue").then(m => m.default || m))
}